import { Injectable } from "@angular/core";
import { BackendProvider } from "../providers/backend.provider";

@Injectable()
export class DetailService {

  private currentStage: any = {};

  constructor(private backend: BackendProvider) {}
  

  public async getAssetHistory(assetId: string): Promise<any> {
    const params = [{
      key: 'filter',
      value: `{"where": {"bottle": "resource:test.wntr.com.Bottle%23${assetId}"}}`
    }];

    return this.backend.get('/ChangeCompany', params)
      .then(result => this.parseResult(result))
      .catch(err => {
        throw err ? 'err_api_call' : 'err_response_parse';
      });
  }

  private parseResult(result: any): any {
    try {
      const stages = [];
      for(const item of result) {
        const stage = item.notes.replace(/'/g, '"');
        stages.push(JSON.parse(stage));
      }

      return stages.sort((a, b) => a.code - b.code);
    }
    catch(err) {
      console.error('Error parsing API response:', err);
      throw null;
    } 
  }

  public setCurrentStage({headerData, code}) {
    this.currentStage = {
      headerData,
      code,
    };
  }

  public getCurrentStage() {
    return this.currentStage;
  }

}
